'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxImmutable = require('redux-immutable');

var _popupActiveReducer = require('./popupActiveReducer');

var _popupActiveReducer2 = _interopRequireDefault(_popupActiveReducer);

var _iconsPopupReducer = require('../../workspace/toolbar/selectionTools/iconTools/popup/iconsPopupReducer');

var _iconsPopupReducer2 = _interopRequireDefault(_iconsPopupReducer);

var _sharingPopupReducer = require('../../workspace/header/utils/sharing/sharingPopupReducer');

var _sharingPopupReducer2 = _interopRequireDefault(_sharingPopupReducer);

var _exportPopupReducer = require('../../workspace/header/utils/export/exportPopupReducer');

var _exportPopupReducer2 = _interopRequireDefault(_exportPopupReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reduxImmutable.combineReducers)({
    active: _popupActiveReducer2.default,
    icons: _iconsPopupReducer2.default,
    sharing: _sharingPopupReducer2.default,
    exporting: _exportPopupReducer2.default
});


//////////////////
// WEBPACK FOOTER
// ./src/client/components/popupPanel/popupReducer.js
// module id = 1928
// module chunks = 0